import * as core from '../../../../../../../core'
import * as changeImpactTeam from '../change-impact-team'

export const RESOURCE = {
  payload: {
    description: 'Change Management',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactTeam.RESOURCE.payload.partialId,
    }),
    id: 'Change Management',
    name: 'Change Management',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
